<template>
  <li
    v-if="attachment"
    class="multimedia-search-result"
  >
    <button
      class="attachment-button"
      @click="attachmentClicked"
    >
      <template v-if="displayAttachment">
        <img
          :src="displayAttachment.smallThumbnail"
          alt=""
          class="attachment-thumbnail image"
        >
        <attachment-progress
          v-if="attachmentState"
          :duration="attachment.metadata && attachment.metadata.duration"
          :watched="attachmentState.currentTimestamp"
        />
      </template>
      <div
        v-else
        class="attachment-thumbnail"
      >
        <icon
          class="thumbnail-icon"
          :name="attachment.icon"
          variant="767676"
        />
        <attachment-progress
          v-if="attachmentState"
          :duration="attachment.metadata && attachment.metadata.duration"
          :watched="attachmentState.currentTimestamp"
        />
      </div>
      <div class="attachment-details">
        <span
          class="attachment-name"
        >{{ attachment.assetTitle }}</span>
        <div class="attachment-metadata">
          <icon
            :name="attachment.icon"
            class="attachment-icon"
            variant="767676"
          />
          <span class="attachment-duration">
            {{ attachment.duration }}
          </span>
        </div>
      </div>
    </button>
  </li>
</template>

<script>
import AttachmentProgress from '@/components/ui/attachment-progress';
import Icon from '@/components/singletons/icon';
import GlobalMixin from '@/mixins/global';

export default {
  components: { AttachmentProgress, Icon },
  mixins: [ GlobalMixin ],
  props: {
    attachmentId: {
      type: Number,
    },
  },
  emits: ['clicked-result'],
  computed: {
    attachment() {
      return this.$store.getters['attachments/get'][this.attachmentId];
    },
    attachmentState() {
      return this.$store.getters['attachmentStates/get'][this.attachmentId];
    },
    displayAttachment() {
      if (this.attachment?.displayAttachmentId) {
        return this.$store.getters['attachments/get'][this.attachment.displayAttachmentId];
      }
    },
  },
  methods: {
    attachmentClicked() {
      this.$emit('clicked-result', this.attachment, 'Attachment');
    },
  },
};
</script>

<style lang="scss" scoped>
.multimedia-search-result {
  .attachment-button {
    margin: rem-calc(16);
    height: rem-calc(64);
    display: flex;
    background: transparent;
    border: 0;
    width: 100%;
    text-align: left;
  }

  .attachment-thumbnail {
    background-color: #ebedef;
    position: relative;
    width: rem-calc(100);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: rem-calc(16);
    height: 100%;

    &.image {
      object-fit: cover;
      object-position: center;
    }

    .thumbnail-icon {
      width: rem-calc(24);
    }
  }

  .attachment-details {
    flex: 1;
    margin: auto 0;

    .attachment-name {
      font-weight: $semi-bold;
    }

    .attachment-metadata {
      margin-top: rem-calc(4);
      color: #767676;
      font-size: rem-calc(14);
      .attachment-icon {
        width: rem-calc(16);
      }
    }
  }

  .play-icon {
    width: rem-calc(24);
  }
}
</style>
